'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./components/scrollPerformance'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/drillDownMenu'));
    processInclude(require('./components/cookie').handleCookieWarningMessage);
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/storeCountrySelector'));
    processInclude(require('./components/themeToggle'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./components/initPopOver'));
    processInclude(require('./components/swiperSlider'));
    processInclude(require('./thirdParty/zendeskinit'));
    processInclude(require('./product/addToCart'));
    processInclude(require('./components/videoElement'));
    processInclude(require('./thirdParty/bootstrapToggleStateManager'));
    processInclude(require('./components/countdown'));
    processInclude(require('./components/scrollTo'));
    processInclude(require('./components/initRemoteHeaderAndFooter'));
    processInclude(require('./components/initStickyAlertLauncher'));
    processInclude(require('./components/initStickyElements'));
    processInclude(require('./components/lightbox'));
});

require('./thirdParty/bootstrap');
require('./components/spinner');
